import AddBucketsRecordView from './views/AddBucketsRecordView.vue'
import AddPackingRecordView from './views/AddPackingRecordView.vue'
import AddChickenWeightRecordView from './views/AddChickenWeightRecordView.vue'

import ViewWithChild from '../ViewWithChild.vue'
import EggStockAddStockIn from './components/EggStockAddStockIn.vue'
import EggStockBalance from './components/EggStockBalance.vue'
import EggStockCount from './components/EggStockCount.vue'

import EggOrdersListOpen from './components/EggOrdersListOpen.vue'
import EggOrder from './components/EggOrder.vue'

import BatchesView from './views/BatchesView.vue'
import BatchView from './views/BatchView.vue'

export default [
  {
    path: '/layers/capture', name: 'layers/capture', navHide: true, component: ViewWithChild, meta: { role: 'Layers', title: 'Capture', layout: 'fluid' },
    children: [
      { path: 'buckets-record', name: 'layers/capture/buckets-record', component: AddBucketsRecordView, meta: { role: 'Layers', title: 'Weigh Buckets', layout: 'narrow' } },
      { path: 'packing-record', name: 'layers/capture/packing-record', component: AddPackingRecordView, meta: { role: 'Layers', title: 'Pack Eggs', layout: 'narrow' } },
      { path: 'chicken-weight-record', name: 'layers/capture/chicken-weight-record', component: AddChickenWeightRecordView, meta: { role: 'Layers', title: 'Weigh Chickens', layout: 'narrow' } },
    ]
  },

  {
    path: '/layers/stock', name: 'layers/stock', navHide: true, component: ViewWithChild, meta: { role: 'Layers', title: 'Stock', layout: 'fluid' },
    children: [
      { path: 'stock-in', component: EggStockAddStockIn, name: 'layers/stock/stock-in', meta: { role: 'Layers', title: 'Stock In', layout: 'narrow' } },
      { path: 'balance', component: EggStockBalance, name: 'layers/stock/balance', meta: { role: 'Layers', title: 'Balance', layout: 'narrow' } },
      { path: 'count', component: EggStockCount, name: 'layers/stock/count', meta: { role: 'Layers', title: 'Count Stock', layout: 'narrow' } },
    ],
  },

  {
    path: '/layers/orders', name: 'layers/orders', navHide: true, component: ViewWithChild, meta: { role: 'Layers', title: 'Orders', layout: 'fluid' },
    children: [
      { path: 'list', component: EggOrdersListOpen, name: 'layers/orders/list', meta: { role: 'Layers', title: 'Open Orders', layout: 'narrow' } },
      { path: '/by-id/:id', component: EggOrder, name: 'layer/egg-order/by-id', navHide: true, meta: { role: 'Layers', title: 'Egg Order', layout: 'narrow' }, props: true },
    ],
  },

  { path: '/layers/batches', name: 'layers-batches', component: BatchesView, meta: { role: 'Layers', title: 'Batches', layout: 'narrow' } },
  { path: '/layers/:batchName', name: 'show-layer-batch', navHide: true, component: BatchView, meta: { role: 'Layers', title: 'Show Batch', layout: 'narrow' }, props: true },
]



// WEBPACK FOOTER //
// ./src/layer/routes.js